var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-navbar-modal"},[_c('b-alert',{staticClass:"nav-alert-modal",attrs:{"variant":_vm.alertType,"show":_vm.alertMessage.length > 0,"dismissible":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.alertMessage)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }